// Auto-generated by scripts/generateBuildInfo.js
// Do not edit manually.
export const buildInfo = {
  appVersion: "0.1.0",
  buildDateIso: "2026-09-30T07:21:43.153Z",
  buildDateDisplay: "2026-09-30",
  buildVersion: "2026.09.30.0721",
} as const;
